
	/**
	 * Event emitter util
	 * Example: POV.emit('NavDrawer:open', { foo: 1 });
	 */
	export function emit(type, detail, element) {
		try {
			var target = element || window;
			var event = new CustomEvent(type, { detail: detail });
			target.dispatchEvent(event);
		} catch (error) {
			console.log('POV.emit error: ', error)
		}
	}
	
	export function debounce(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}

	export function nodeList(str, root) {
		if (!root) root = document;
		var nodeList = root.querySelectorAll(str);
		return Array.prototype.slice.call(nodeList);
	}

	export function val(node) {
		return node.value;
	}

	/**
	 * Formats cents with a Shopify money format, e.g. formatMoney(15995, '${{amount}}') -> '$159.95'.
	 * Both stores use the plain {{amount}} placeholder (2 decimals, comma thousands), so that is all
	 * it handles. The result may contain markup: the Canada format is '<small>C</small>${{amount}}'.
	 * @param {number|string} cents Amount in the shop's currency subunits
	 * @param {string} format Shopify money format, e.g. shop.money_with_currency_format
	 * @return {string} The formatted amount
	 */
	export function formatMoney(cents, format) {
		var amount = (Number(cents) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
	}

	// Array Utils
	export function head(arr) {
		return arr[0];
	}

	export function last(arr) {
		return arr[arr.length - 1];
	}

	export function arraysEqual(arr1, arr2) {
		return JSON.stringify(arr1) === JSON.stringify(arr2);
	}

	export function keys(obj) {
		return Object.keys(obj);
	}

	// Functional Utils
	export function pluck(array, key) {
		return array.map(function(obj) {
			return obj[key];
		});
	}

	export function partial(fn) {
		var slice = Array.prototype.slice;
		var args = slice.call(arguments, 1);
		return function() {
			return fn.apply(this, args.concat(slice.call(arguments, 0)));
		};
	}

	export function compose() {
		var funcs = Array.prototype.slice.call(arguments).reverse();
		return function() {
			return funcs.slice(1).reduce(function(res, fn) {
				return fn(res);
			}, funcs[0].apply(undefined, arguments));
		};
	}

	window.POV = window.POV || {};
	window.POV.utils = {
		compose,
		partial,
		head,
		last,
		debounce,
		nodeList,
		emit,
		formatMoney
	}
